export const getSignedAgreements = agreements =>
  (agreements || []).filter(agreement => agreement.accepted).map(agreement => agreement.type);

